<template>
  <v-dialog v-model="openMode" max-width="600px" persistent>
    <v-card class="dialog-card">
      <v-card-title class="dialog-header" :class="formTitle === 'ערוך חבילה' ? 'edit-header' : 'create-header'">
        <span class="dialog-title">{{ formTitle }}</span>
        <v-btn icon dark @click="openMode = false" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="dialog-content">
        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="form-section">
            <h3 class="section-title">פרטים בסיסיים</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.name" outlined dense label="שם חבילה"
                  :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-tag"
                  class="form-field"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.price" outlined dense label="מחיר" type="number" hide-spin-buttons
                  :rules="priceRules" required prepend-inner-icon="mdi-currency-ils"
                  :disabled="itemEdited.bill_type === 'ravkol'" class="form-field"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="itemEdited.bill_type" :items="billTypeOptions" item-text="text" item-value="value"
                  outlined dense label="סוג חיוב" :rules="[v => !!v || 'שדה חובה']" required
                  prepend-inner-icon="mdi-credit-card" @change="onBillTypeChange" class="form-field"></v-select>
                <div v-if="itemEdited.bill_type === 'ravkol'" class="ravkol-info">
                  <v-alert type="info" dense outlined class="mt-2">
                    <v-icon slot="prepend">mdi-information</v-icon>
                    עבור חבילות רב-קול, המחיר חייב להיות 0
                  </v-alert>
                </div>
              </v-col>
            </v-row>
          </div>

          <div class="form-section">
            <h3 class="section-title">מאפייני חבילה</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.channels" outlined dense label="ערוצים" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-broadcast"
                  class="form-field"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.contacts" outlined dense label="אנשי קשר" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-account-group"
                  class="form-field"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.storage" outlined dense label="גי'גה אחסון" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-database"
                  class="form-field"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="form-section">
            <h3 class="section-title">הגדרות נוספות</h3>
            <v-row>
              <v-col cols="12">
                <v-switch v-model="itemEdited.show_to_user" color="primary"
                  :label="`הצג למשתמשים: ${itemEdited.show_to_user ? 'כן' : 'לא'}`" class="visibility-switch"
                  hide-details></v-switch>
              </v-col>
              <v-col cols="12"
                v-if="itemEdited.price != null && itemEdited.price == 0 && itemEdited.bill_type !== 'ravkol'">
                <v-switch v-model="itemEdited.is_trial" color="primary"
                  :label="`חבילת ניסיון: ${itemEdited.is_trial ? 'כן' : 'לא'}`" class="visibility-switch"
                  hide-details></v-switch>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn text @click="openMode = false" class="cancel-btn" :disabled="progressShow">
          ביטול
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="formTitle === 'ערוך חבילה' ? saveEditedPlan() : saveNewPlan()" class="save-btn"
          :loading="progressShow" :disabled="progressShow">
          <v-icon left>{{ formTitle === 'ערוך חבילה' ? 'mdi-content-save' : 'mdi-plus-circle' }}</v-icon>
          {{ formTitle === 'ערוך חבילה' ? 'שמור שינויים' : 'צור חבילה' }}
        </v-btn>
      </v-card-actions>

      <!-- Loading Indicator -->
      <v-overlay :value="progressShow" v-if="progressShow" absolute class="loading-overlay">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </v-overlay>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    planToEdit: Object,
    formTitle: String,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    itemEdited: {
      name: "",
      channels: "",
      storage: "",
      contacts: "",
      price: "",
      show_to_user: false,
      is_trial: false,
      bill_type: "",
    },
    billTypeOptions: [
      { text: 'הו"ק', value: "postpaid" },
      { text: "חד פעמי", value: "prepaid" },
      { text: "רב-קול", value: "ravkol" },
      { text: "ניסיון", value: "trial" }
    ]
  }),
  computed: {
    priceRules() {
      const rules = [v => v !== null && v !== undefined && v !== '' || 'שדה חובה'];

      if (this.itemEdited.bill_type === 'ravkol') {
        rules.push(v => v == 0 || 'המחיר חייב להיות 0 עבור חבילות רב-קול');
      }

      return rules;
    }
  },
  methods: {
    onBillTypeChange(value) {
      if (value === 'ravkol') {
        // When selecting Rav-Kol bill type, set price to 0
        this.itemEdited.price = 0;
        // Also disable trial mode since it's for Rav-Kol
        this.itemEdited.is_trial = false;
      }
    },

    async saveNewPlan() {
      if (this.$refs.form.validate()) {
        try {
          this.progressShow = true;
          const ivrJSON = JSON.stringify({ plan: this.itemEdited });
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + "/admin_api/create_plan";

          const res = await fetch(api, ApiServices.requestOptions("POST", ivrJSON, token));
          const jsonObject = await res.json();

          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planCreated", this.itemEdited, "החבילה נוצרה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.showSnackBar("Error saved new plan: " + error, "red");
        } finally {
          this.progressShow = false;
        }
      }
    },

    async saveEditedPlan() {
      if (this.$refs.form.validate()) {
        try {
          this.progressShow = true;
          const ivrJSON = JSON.stringify({ plan: this.itemEdited });
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + "/admin_api/edit_plan";

          const res = await fetch(api, ApiServices.requestOptions("PUT", ivrJSON, token));
          const jsonObject = await res.json();

          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planEdited", this.itemEdited, "החבילה עודכנה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.showSnackBar("Error saved edited plan: " + error, "red");
        } finally {
          this.progressShow = false;
        }
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
  },
  mounted() {
    if (this.formTitle === "ערוך חבילה") {
      this.itemEdited = JSON.parse(JSON.stringify(this.planToEdit));
    } else {
      // Set default values for new plan
      this.itemEdited = {
        name: "",
        channels: "",
        storage: "",
        contacts: "",
        price: "",
        show_to_user: true,
        is_trial: false,
        bill_type: "",
      };
    }
  },
}
</script>

<style scoped>
.dialog-card {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  color: white;
}

.create-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
}

.edit-header {
  background: linear-gradient(135deg, #fdbd29 0%, #ffcf5c 100%);
  color: #0d2c6d;
}

.dialog-title {
  font-size: 1.4rem;
  font-weight: 600;
}

.close-btn {
  margin-right: -8px;
}

.dialog-content {
  padding: 24px;
}

.form-section {}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.form-field {}

.visibility-switch {
  margin-top: 8px;
}

.ravkol-info {
  margin-top: 8px;
}

.dialog-actions {
  padding: 16px 24px;
  background-color: #f8f9fa;
}

.save-btn {
  background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
  color: #0d2c6d !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 44px;
}

.cancel-btn {
  color: #666;
}

.loading-overlay {
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
}

@media (max-width: 600px) {
  .dialog-header {
    padding: 16px 20px;
  }

  .dialog-title {
    font-size: 1.2rem;
  }

  .dialog-content {
    padding: 16px;
  }

  .dialog-actions {
    padding: 12px 16px;
  }
}
</style>